import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseApi from "../../api/baseApi";

import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialState = {
  settings: {},
  settingsLoading: true,
  settingsRefresh: true,

  updateSettingLoading: false,
};

export const fetchSetting = createAsyncThunk(
  "setting/fetchSetting",
  async () => {
    try {
      const response = await baseApi.get(`/GlobalSetting`);

      toast.dismiss();

      return response.data.Value;
    } catch (error) {
      toast.error({
        render: "Hata: " + error.response.data.Error.Description,
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const updateSetting = createAsyncThunk(
  "setting/updateSetting",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        autoClose: 2000,
        transition: Slide,
        hideProgressBar: false,
      });

      throw new Error(errMsg);
    }

    const data = {
      carYearLimit: parseInt(values.carYearLimit),
      isCarYearLimitEnabled: values.isCarYearLimitEnabled,
    };

    const loadingToast = toast.loading("Lütfen bekleyin...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.put(`/GlobalSetting`, data);

      toast.update(loadingToast, {
        render: "İşlem başarılı!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error.response?.data?.Error?.Description || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: "Hata: " + errMsg,
        type: "error",
        isLoading: false,
        autoClose: 2000,
        transition: Slide,
        hideProgressBar: false,
      });

      throw new Error(errMsg);
    }
  }
);

export const settingSlice = createSlice({
  name: "setting",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSetting.pending, (state, action) => {
        state.settings = {};
        state.settingsLoading = true;
      })
      .addCase(fetchSetting.fulfilled, (state, action) => {
        state.settings = action.payload;
        state.settingsLoading = false;
      })
      .addCase(fetchSetting.rejected, (state, action) => {
        state.settings = {};
        state.settingsLoading = false;
      });

    builder
      .addCase(updateSetting.pending, (state, action) => {
        state.updateSettingLoading = true;
      })
      .addCase(updateSetting.fulfilled, (state, action) => {
        state.updateSettingLoading = false;
        state.settingsRefresh = !state.settingsRefresh;
      })
      .addCase(updateSetting.rejected, (state, action) => {
        state.updateSettingLoading = false;
      });
  },
});

export default settingSlice.reducer;
